/** Folder used until an admin sets `cloudinaryFolder` */ export var DEFAULT_CLOUDINARY_FOLDER = "blast36";
/** The show's title, without a number until one is known */ export function blastTitle(blastNumber) {
    return blastNumber ? "Blast ".concat(blastNumber) : "Blast";
}

//# sourceMappingURL=info.types.js.map